/* src/app/components/elibraryandcourse/e-library/new-course/new-course.component.scss */
.custom-modal {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  visibility: hidden;
  opacity: 0;
  z-index: 10000;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}
.custom-modal.show {
  visibility: visible;
  opacity: 1;
}
.custom-modal.show .custom-modal-dialog {
  transform: translateY(0) scale(1);
}
.custom-modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}
.custom-modal-dialog {
  position: relative;
  width: 100%;
  max-width: 680px;
  max-height: calc(100vh - 40px);
  display: flex;
  transform: translateY(15px) scale(0.98);
  transition: transform 0.22s ease;
  z-index: 1;
}
.custom-modal-content {
  width: 100%;
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.22), 0 5px 20px rgba(15, 23, 42, 0.08);
}
.custom-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid #edf0f5;
  background: #fff;
}
.modal-title-section {
  display: flex;
  align-items: center;
  gap: 12px;
}
.modal-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 42px;
  border-radius: 11px;
  background:
    linear-gradient(
      135deg,
      #eef3ff,
      #e4ebff);
  color: #3867d6;
  font-size: 17px;
}
.modal-title-section h4 {
  margin: 0;
  color: #1e293b;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
}
.modal-title-section p {
  margin: 3px 0 0;
  color: #929baa;
  font-size: 11px;
}
.close-btn {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 9px;
  background: #f5f6f8;
  color: #778195;
  cursor: pointer;
  transition: all 0.2s ease;
}
.close-btn:hover {
  background: #fff0f0;
  color: #e05252;
  transform: rotate(3deg);
}
.close-btn i {
  font-size: 14px;
}
.custom-modal-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 22px;
  scrollbar-width: thin;
  scrollbar-color: #d9dee8 transparent;
}
.custom-modal-body::-webkit-scrollbar {
  width: 5px;
}
.custom-modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.custom-modal-body::-webkit-scrollbar-thumb {
  background: #d9dee8;
  border-radius: 10px;
}
.error-notify {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin-bottom: 20px;
  padding: 12px 14px;
  border: 1px solid #ffd7d7;
  border-radius: 10px;
  background: #fff6f6;
}
.error-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  color: #df4f4f;
  font-size: 14px;
}
.error-content strong {
  display: block;
  color: #c53d3d;
  font-size: 12px;
  font-weight: 700;
}
.error-content p {
  margin: 3px 0 0;
  color: #a15d5d;
  font-size: 11px;
  line-height: 1.5;
}
.form-section {
  padding: 17px;
  border: 1px solid #edf0f5;
  border-radius: 13px;
  background: #fff;
}
.form-section + .form-section {
  margin-top: 15px;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 19px;
}
.section-title > i {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f4f7ff;
  color: #3867d6;
  font-size: 13px;
}
.section-title h5 {
  margin: 0;
  color: #263044;
  font-size: 13px;
  font-weight: 700;
}
.section-title span {
  display: block;
  margin-top: 2px;
  color: #99a1b0;
  font-size: 10px;
}
.form-row {
  margin-bottom: 17px;
}
.form-row:last-child {
  margin-bottom: 0;
}
.form-row label {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-bottom: 7px;
  color: #4a5568;
  font-size: 11.5px;
  font-weight: 600;
}
.required {
  color: #e05252;
}
.optional {
  margin-left: 5px;
  color: #a5adba;
  font-size: 9px;
  font-weight: 400;
}
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  height: 41px;
  border: 1px solid #dfe4ec;
  border-radius: 9px;
  background: #fff;
  transition: all 0.2s ease;
}
.input-wrapper:focus-within {
  border-color: #8ba6ea;
  box-shadow: 0 0 0 3px rgba(56, 103, 214, 0.08);
}
.input-wrapper > i {
  margin-left: 12px;
  color: #9ba4b3;
  font-size: 12px;
}
.form-input {
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 0 11px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #344054;
  font-size: 12px;
}
.form-input::placeholder {
  color: #a7afbc;
}
.textarea-wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
  min-height: 76px;
  border: 1px solid #dfe4ec;
  border-radius: 9px;
  background: #fff;
  transition: all 0.2s ease;
}
.textarea-wrapper:focus-within {
  border-color: #8ba6ea;
  box-shadow: 0 0 0 3px rgba(56, 103, 214, 0.08);
}
.textarea-wrapper > i {
  margin: 13px 0 0 12px;
  color: #9ba4b3;
  font-size: 12px;
}
.form-textarea {
  flex: 1;
  width: 100%;
  min-height: 74px;
  padding: 11px;
  resize: vertical;
  border: 0;
  outline: 0;
  background: transparent;
  color: #344054;
  font-size: 12px;
  line-height: 1.5;
}
.form-textarea::placeholder {
  color: #a7afbc;
}
.field-hint {
  display: block;
  margin-top: 5px;
  color: #a0a8b5;
  font-size: 9.5px;
}
.select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  height: 41px;
  border: 1px solid #dfe4ec;
  border-radius: 9px;
  background: #fff;
}
.select-wrapper:focus-within {
  border-color: #8ba6ea;
  box-shadow: 0 0 0 3px rgba(56, 103, 214, 0.08);
}
.select-wrapper > i:first-child {
  margin-left: 12px;
  color: #9ba4b3;
  font-size: 12px;
}
.form-select {
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 0 35px 0 10px;
  border: 0;
  outline: 0;
  appearance: none;
  background: transparent;
  color: #4b5565;
  font-size: 12px;
  cursor: pointer;
}
.select-arrow {
  position: absolute;
  right: 13px;
  color: #98a1b0;
  font-size: 9px;
  pointer-events: none;
}
.access-section {
  padding-bottom: 12px;
}
.access-title {
  justify-content: space-between;
}
.section-title-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.section-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 12px;
}
.users-icon {
  background: #eef8f5;
  color: #1fa77a;
}
.selected-count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border-radius: 20px;
  background: #edf8f4;
  color: #238e6b;
  font-size: 9px;
  font-weight: 600;
  white-space: nowrap;
}
.selected-count i {
  font-size: 8px;
}
.user-list-container {
  height: 190px;
  overflow-y: auto;
  padding: 3px;
  border: 1px solid #e7ebf1;
  border-radius: 10px;
  background: #fafbfc;
  scrollbar-width: thin;
  scrollbar-color: #d9dee8 transparent;
}
.user-list-container::-webkit-scrollbar {
  width: 5px;
}
.user-list-container::-webkit-scrollbar-track {
  background: transparent;
}
.user-list-container::-webkit-scrollbar-thumb {
  background: #d9dee8;
  border-radius: 10px;
}
.user-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.user-item {
  display: flex;
  align-items: center;
  min-height: 55px;
  margin-bottom: 3px;
  padding: 7px 9px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.18s ease;
}
.user-item:hover {
  border-color: #dce4f5;
  background: #f7f9ff;
}
.user-item:hover .user-avatar {
  background: #e7edff;
  color: #3867d6;
}
.user-item.selected {
  border-color: #d7e2ff;
  background: #f2f5ff;
}
.user-item.selected .user-avatar {
  background: #dce6ff;
  color: #3867d6;
}
.user-item.selected .user-name {
  color: #315cc4;
}
.user-avatar {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  border-radius: 9px;
  background: #f1f3f6;
  color: #7d8797;
  font-size: 12px;
  transition: all 0.18s ease;
}
.user-info {
  flex: 1;
  min-width: 0;
  margin-left: 9px;
}
.user-name {
  display: block;
  overflow: hidden;
  color: #465166;
  font-size: 11.5px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-status {
  display: block;
  margin-top: 2px;
  color: #a0a8b5;
  font-size: 9px;
}
.user-check {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  border: 1px solid #dfe4ec;
  border-radius: 7px;
  color: transparent;
  transition: all 0.18s ease;
}
.user-check.visible {
  border-color: #3867d6;
  background: #3867d6;
  color: #fff;
}
.user-check i {
  font-size: 9px;
}
.no-users {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
.no-users-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  border-radius: 50%;
  background: #f1f3f6;
  color: #9aa3b1;
  font-size: 15px;
}
.no-users strong {
  color: #626d7e;
  font-size: 11px;
}
.no-users span {
  margin-top: 3px;
  color: #a3abb8;
  font-size: 9px;
}
.custom-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 14px 22px;
  border-top: 1px solid #edf0f5;
  background: #fcfcfd;
}
.footer-info {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #9aa3b2;
  font-size: 9px;
}
.footer-info i {
  color: #9aa3b2;
  font-size: 10px;
}
.footer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.btn {
  height: 37px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 15px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-cancel {
  border: 1px solid #dfe4ec;
  background: #fff;
  color: #667085;
}
.btn-cancel:hover {
  border-color: #cbd2dc;
  background: #f8f9fb;
  color: #465166;
}
.btn-primary {
  border: 1px solid #3867d6;
  background: #3867d6;
  color: #fff;
  box-shadow: 0 4px 10px rgba(56, 103, 214, 0.18);
}
.btn-primary:hover:not(:disabled) {
  border-color: #2f58bd;
  background: #2f58bd;
  transform: translateY(-1px);
  box-shadow: 0 7px 16px rgba(56, 103, 214, 0.22);
}
.btn-primary:disabled {
  border-color: #d9dee7;
  background: #e9ecf1;
  color: #a4acb8;
  box-shadow: none;
  cursor: not-allowed;
}
.btn-primary i {
  font-size: 10px;
}
@media (max-width: 767.98px) {
  .custom-modal {
    padding: 12px;
  }
  .custom-modal-dialog {
    max-width: 100%;
    max-height: calc(100vh - 24px);
  }
  .custom-modal-content {
    max-height: calc(100vh - 24px);
    border-radius: 15px;
  }
  .custom-modal-header {
    padding: 15px 16px;
  }
  .custom-modal-body {
    padding: 16px;
  }
  .custom-modal-footer {
    padding: 12px 16px;
  }
  .footer-info {
    display: none;
  }
  .footer-actions {
    width: 100%;
  }
  .footer-actions .btn {
    flex: 1;
  }
}
@media (max-width: 480px) {
  .custom-modal {
    align-items: flex-end;
    padding: 0;
  }
  .custom-modal-dialog {
    width: 100%;
    max-height: 94vh;
    transform: translateY(20px);
  }
  .custom-modal-content {
    max-height: 94vh;
    border-radius: 18px 18px 0 0;
  }
  .custom-modal-header {
    padding: 14px 15px;
  }
  .modal-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    font-size: 15px;
  }
  .modal-title-section h4 {
    font-size: 15px;
  }
  .modal-title-section p {
    font-size: 10px;
  }
  .custom-modal-body {
    padding: 14px;
  }
  .form-section {
    padding: 13px;
  }
  .section-title {
    margin-bottom: 15px;
  }
  .user-list-container {
    height: 175px;
  }
  .custom-modal-footer {
    padding: 12px 14px;
  }
  .btn {
    height: 39px;
  }
}
/*# sourceMappingURL=new-course.component.css.map */
